<template>
  <div>
    <div class="report-card">
      <div class="report-card-header" v-if="title">
        <div class="left">
          <p class="title">{{ title }}</p>
        </div>
        <div class="right">
          <slot name="headerRight" />
        </div>
      </div>
      <div class="report-card-content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
}
</script>

<style lang="scss" scoped>
.report-card {
  background: #ffffff;
  box-shadow: 0rem 0rem 0rem rgba(34, 36, 46, 0.02);
  border-radius: 0.32rem;
  padding: 0.53rem 0.48rem;
  margin-bottom: 0.48rem;

  &-header {
    .title {
      font-size: 0.43rem;
      font-weight: 500;
      color: #22242e;
    }
  }
}
</style>
